export default class LocationStore {
    constructor(rootStore) {
        Object.defineProperty(this, "rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "setLocation", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: (event) => {
                this.rootStore.externalCallbackStore.onPathChange(event);
            }
        });
        this.rootStore = rootStore;
    }
}
//# sourceMappingURL=LocationStore.js.map